import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { STORAGE_API, type Storage } from '@chess/api-storage';
import { useChesscom } from './store';
import './settings-chesscom.css';

// The chess.com section of the settings screen: the account whose games
// the library imports. Saved through the storage API under `settings/`.
export function setup(app: PiletApi) {
  const storage = app.getApi<Storage>(STORAGE_API).then((s) => s.scope('settings'));

  const Section: React.FC = () => {
    const { draft, username, status, error, setDraft, load, save } = useChesscom();
    React.useEffect(() => {
      storage.then(load);
    }, []);
    const dirty = draft.trim() !== username;
    const onSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      storage
        .then(save)
        .then(() => app.emit('settings.chesscom.changed', { username: useChesscom.getState().username }));
    };
    return (
      <section className="panel settings-chesscom">
        <h2>chess.com</h2>
        <form className="settings-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="settings-chesscom-username">Username</label>
            <input
              id="settings-chesscom-username"
              className="input"
              type="text"
              autoComplete="off"
              spellCheck={false}
              placeholder="your chess.com username"
              value={draft}
              disabled={status === 'loading'}
              onChange={(e) => setDraft(e.target.value)}
            />
            <p className="settings-help">The account whose games the library imports.</p>
          </div>
          <div className="settings-actions">
            <button type="submit" className="btn btn-primary" disabled={!dirty || status === 'saving' || status === 'loading'}>
              Save
            </button>
            <span className="settings-status" data-status={status}>
              {status === 'loading' && 'Loading…'}
              {status === 'saving' && 'Saving…'}
              {status === 'saved' && !dirty && 'Saved'}
              {status === 'error' && (error ?? 'Could not save')}
            </span>
          </div>
        </form>
      </section>
    );
  };

  app.registerExtension('settings.sections', Section, { order: 10 });
}
